import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { BuildingForm as CreateBuildingForm } from '../project-forms/building.form';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { Project } from '../../../models/project';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

interface CreateBuildingButtonProps {
  onBuildingCreated: (data: Project) => void;
  projectID: number;
  syncWithDux: any;
  projectTypeValue: any;
  existingData: any;
}

export const CreateBuildingButton = ({
  projectID,
  syncWithDux,
  projectTypeValue,
  existingData,
  onBuildingCreated,
}: CreateBuildingButtonProps) => {
  const [newBuilding, setNewBuilding] = useState<any>();

  // const isProjectTypeRES = projectTypeValue === "RES";
  const isProjectTypeRES = true;

  const validationSchema = Yup.object().shape({
    buildingData: Yup.object().shape({
      buildingName: Yup.string().required('Building name is required'),
      floorsCount: Yup.string().required('Floor count is required'),
      // lotType: Yup.string().required('Lot type is required'),
      buildingFloors: Yup.array(
        Yup.object({
          floorNo: Yup.string().required('Floor number is required'),
          unitsCount: Yup.string().required('Unit count is required'),
        })
      ),
      buildingCommonAreas: Yup.array(
        Yup.object({
          commonAreaName: Yup.string().required('Name is required'),
          commonAreaFloorNo: Yup.string().required('Floor number is required'),
          lotType: isProjectTypeRES ? Yup.string().required('Lot type is required') : Yup.string().notRequired(),
        })
      ),
    }),
  });

  const handleDialogClose = () => {
    setNewBuilding(undefined);
  };

  const handleAddBuilding = () => {
    const initialCommonArea = {
      commonAreaName: '', // Example initial value for commonAreaName
      commonAreaFloorNo: '', // Example initial value for commonAreaFloorNo
      jobsite: '', // Initialize jobsite with an empty string
      address: '', // Example initial value for address
      lotType: '',
    };
    const initialBuildingData = {
      // Assuming buildingFloors is initially empty
      buildingCommonAreas: [initialCommonArea], // Array containing initialCommonArea
    };
    setNewBuilding({
      projectID,
      buildingName: '',
      //  buildingData: initialBuildingData
    });
  };

  const formatSubmitData = (data: any) => {
    const { buildingFloors, buildingName, buildingCommonAreas } = data.buildingData;
    return {
      projectID,
      buildingName,
      floorsCount: buildingFloors?.length,
      buildingFloors: buildingFloors?.map((f: any) => ({ ...f, projectID, buildingName })),
      buildingCommonAreas: buildingCommonAreas?.map((a: any) => ({ ...a, projectID, buildingName })),
    };
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_UNIT]}>
          <Button className="btn btn-primary" variant="text" sx={{ p: 0, m: 0, ml: 1 }} onClick={handleAddBuilding}>
            ADD NEW BUILDING
          </Button>
        </GuardedComponent>
      </div>
      {newBuilding && (
        <SaveHookFormDialog
          title={'CREATE BUILDING'}
          config={{
            saveConfig: projectsApiKeyStore.createBuilding(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onBuildingCreated}
          formatSubmitdata={formatSubmitData}
          size="xl"
          yupSchema={validationSchema}
        >
          <CreateBuildingForm
            name="buildingData"
            syncWithDux={syncWithDux}
            projectID={String(projectID)}
            projectTypeValue={projectTypeValue}
            existingData={existingData}
          />
        </SaveHookFormDialog>
      )}
    </>
  );
};
